import { APIConfiguration } from '@savgroup-front-common/configuration';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants/shared';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.repairer}technicalIntervention/states/${COMMON_QUERY_PARAMS.SELLER_ID}`;

export interface UpsertTechnicalInterventionStatesBySellerCommandPayload {
  sellerId: string;
  states: string[];
}

export const upsertTechnicalInterventionStatesBySellerCommand = async ({
  sellerId,
  states,
}: UpsertTechnicalInterventionStatesBySellerCommandPayload): Promise<
  BackResponse<string[]> | BackResponseFailure
> => {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId);

    const response: BackResponse<string[]> = await apiCall(url, {
      method: SUPPORTED_METHODS.POST,
      json: { states },
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
